import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import AuthProvider from './context/AuthProvider';
import { HelmetProvider } from 'react-helmet-async'; // Import HelmetProvider
import { StoreProvider } from './context/StoreContext';
import CartProvider from './context/CartContext';
import { ContactProvider } from './context/ContactContext';
import GTMProvider from './context/GTMProvider';
import { AnalyticsProvider } from './context/AnalyticsProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        
        <GTMProvider>
          <AnalyticsProvider>

            <AuthProvider>

              <ContactProvider>
                  <StoreProvider>
                    <CartProvider>
                      <App />
                    </CartProvider>
                  </StoreProvider>
              </ContactProvider>

            </AuthProvider>
            
          </AnalyticsProvider>
        </GTMProvider>

        
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();